import { Box, Card, Stack, Typography } from "@compass/core";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { DraggableHandle } from "./DashboardGrid";
import { DASHBOARD_CARD_HEADER_SX} from "../styles/cardStyles";

type Props = {
    title: string;
    children: React.ReactNode;
    rightActions?: React.ReactNode;
    showDragHandle?: boolean;
};

export const DashboardCard: React.FC<Props> = ({ title, children, rightActions, showDragHandle = true }) => {
    return (
        <Box
            sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
        <Card
            header={
                <Box
                    sx={{
                        ...DASHBOARD_CARD_HEADER_SX,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        userSelect: "none"
                    }}
                >
                    <Typography variant="h6">{title}</Typography>
                    <Stack direction="row" spacing="sm" alignItems="center">
                        {rightActions}
                        {showDragHandle && (
                            <DraggableHandle>
                                <DragIndicatorIcon style={{ color: "rgba(255,255,255,0.7)" }} />
                            </DraggableHandle>
                        )}
                    </Stack>
                </Box>
            }
            fullHeight
            headerSx={DASHBOARD_CARD_HEADER_SX}
        >
            {children}
        </Card>
      </Box >  
    );
};
